<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="Perfect-Center"><span class="Bold-Italic">In loving dedication to The Yo-Yos, lifelong serial friends: Ellen, Ginny, Joan, Jutta, Pennie, and Randi…plus honorary Yo-Yo, Wayne</span></p>
<p class="Perfect-Center"><span class="Bold-Italic">A special thank you to Stevan Gould and Patty Gordon, plus WildBlue Press and their amazing staff: Steve Jackson, Michael Cordova, Ashley Kaesemeyer, and Rowe Carenen</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Foreword2.vue?70301d62